/* =============================================
   TECH MYTH BUSTERS  - GAME LOGIC
   Requires: myths.js and products.js loaded first
   ============================================= */

(function () {
  'use strict';

  /* ------------------------------------------
     ANALYTICS STUBS
     Replace the body of trackEvent() with your
     real analytics call once you're ready.

     Google Analytics 4 example:
       gtag('event', eventName, data);

     Meta Pixel example:
       fbq('track', eventName, data);
  ------------------------------------------ */
  function trackEvent(eventName, data) {
    // console.log('[TMB]', eventName, data);
    // TODO: wire up real analytics here
  }


  /* ------------------------------------------
     GAME STATE
  ------------------------------------------ */
  var state = {
    myths: [],
    currentIndex: 0,
    score: 0,
    wrongProductIds: [],   // product ids from myths the user got wrong
    isVerdictShowing: false,
    gameStarted: false,

    // Drag state
    isDragging: false,
    dragStartX: 0,
    dragStartY: 0,
    dragCurrentX: 0,
    isHorizontalDrag: null,  // null = undecided
  };


  /* ------------------------------------------
     DOM CACHE
  ------------------------------------------ */
  var el = {};

  function cacheEls() {
    el.hero          = document.getElementById('tmb-hero');
    el.gameSection   = document.getElementById('tmb-game');
    el.resultSection = document.getElementById('tmb-result');
    el.productsSection = document.getElementById('tmb-products');

    el.cardArea      = document.getElementById('tmb-card-area');
    el.cardStack     = document.getElementById('tmb-card-stack');
    el.verdict       = document.getElementById('tmb-verdict');
    el.verdictIcon   = document.getElementById('tmb-verdict-icon');
    el.verdictLabel  = document.getElementById('tmb-verdict-label');
    el.verdictExpl   = document.getElementById('tmb-verdict-expl');
    el.nextBtn       = document.getElementById('tmb-next-btn');

    el.mythNum       = document.getElementById('tmb-myth-num');
    el.mythTotal     = document.getElementById('tmb-myth-total');
    el.scoreCount    = document.getElementById('tmb-score-count');
    el.answeredCount = document.getElementById('tmb-answered-count');
    el.progressFill  = document.getElementById('tmb-progress-fill');
    el.progressBar   = document.getElementById('tmb-progress-bar');
    el.actionBtns    = document.getElementById('tmb-action-btns');
    el.btnTrue       = document.getElementById('tmb-btn-true');
    el.btnFalse      = document.getElementById('tmb-btn-false');

    el.startBtn      = document.getElementById('tmb-start-btn');

    el.finalScoreNum = document.getElementById('tmb-final-score-num');
    el.scoreRingFill = document.getElementById('tmb-score-ring-fill');
    el.resultHeadline = document.getElementById('tmb-result-headline');
    el.resultRank    = document.getElementById('tmb-result-rank');
    el.shareBtn      = document.getElementById('tmb-share-btn');
    el.replayBtn     = document.getElementById('tmb-replay-btn');
    el.confetti      = document.getElementById('tmb-confetti');

    el.productsTitle = document.getElementById('tmb-products-title');
    el.productsGrid  = document.getElementById('tmb-products-grid');

    el.shareWa       = document.getElementById('tmb-share-wa');
    el.shareTw       = document.getElementById('tmb-share-tw');
    el.kbHint        = document.getElementById('tmb-kb-hint');
  }


  /* ------------------------------------------
     INIT
  ------------------------------------------ */
  function init() {
    cacheEls();

    state.myths = shuffle(window.MYTHS || []).slice(0, 10);

    if (el.mythTotal) el.mythTotal.textContent = state.myths.length;

    // Bind static buttons
    if (el.startBtn)  el.startBtn.addEventListener('click', startGame);
    if (el.nextBtn)   el.nextBtn.addEventListener('click', nextMyth);
    if (el.btnTrue)   el.btnTrue.addEventListener('click', function () { triggerAnswer(true); });
    if (el.btnFalse)  el.btnFalse.addEventListener('click', function () { triggerAnswer(false); });
    if (el.shareBtn)  el.shareBtn.addEventListener('click', shareScore);
    if (el.replayBtn) el.replayBtn.addEventListener('click', resetGame);

    // Keyboard nav
    document.addEventListener('keydown', handleKeydown);

    // Pre-render first card so it's visible on scroll
    renderCurrentCard();
  }


  /* ------------------------------------------
     GAME FLOW
  ------------------------------------------ */
  function startGame() {
    if (!state.gameStarted) {
      state.gameStarted = true;
      trackEvent('game_start', { total_myths: state.myths.length });
    }

    // Show keyboard hint briefly on desktop
    showKbHint();

    el.gameSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  function renderCurrentCard() {
    if (state.currentIndex >= state.myths.length) {
      showFinalScore();
      return;
    }

    // Reset card area
    el.cardStack.innerHTML = '';
    el.verdict.style.display = 'none';
    state.isVerdictShowing = false;

    // Show action buttons
    el.actionBtns.style.display = 'flex';

    // Update header stats
    updateProgressUI();

    // Render stack: up to 3 cards deep (current + 2 behind)
    var remaining = state.myths.length - state.currentIndex;
    var stackDepth = Math.min(3, remaining);

    for (var i = stackDepth - 1; i >= 0; i--) {
      createCardEl(state.currentIndex + i, i);
    }

    // Attach drag to active (top) card
    var activeCard = el.cardStack.querySelector('.tmb-card--active');
    if (activeCard) attachDrag(activeCard);
  }

  function createCardEl(mythIndex, stackPos) {
    var myth = state.myths[mythIndex];
    var card = document.createElement('div');
    card.className = 'tmb-card';
    card.setAttribute('role', 'article');
    card.setAttribute('aria-label', 'Tech myth ' + (mythIndex + 1));

    if (stackPos === 0) {
      card.classList.add('tmb-card--active');
      card.style.zIndex = '10';
    } else if (stackPos === 1) {
      card.style.zIndex = '9';
      card.style.transform = 'translateY(10px) scale(0.95)';
      card.style.opacity = '0.75';
      card.style.pointerEvents = 'none';
    } else {
      card.style.zIndex = '8';
      card.style.transform = 'translateY(20px) scale(0.90)';
      card.style.opacity = '0.5';
      card.style.pointerEvents = 'none';
    }

    var catColor = getCategoryColor(myth.category);

    card.innerHTML =
      '<div class="tmb-card-shine"></div>' +
      '<div class="tmb-card-content">' +
        '<div class="tmb-card-category" style="color:' + catColor + ';border-color:' + catColor + '44">' +
          escHtml(myth.category) +
        '</div>' +
        '<p class="tmb-card-statement">' + escHtml(myth.statement) + '</p>' +
        '<div class="tmb-card-footer">' +
          '<span class="tmb-card-hint">← swipe or tap →</span>' +
        '</div>' +
      '</div>' +
      '<div class="tmb-overlay tmb-overlay-true" aria-hidden="true">TRUE ✅</div>' +
      '<div class="tmb-overlay tmb-overlay-false" aria-hidden="true">❌ FALSE</div>';

    el.cardStack.appendChild(card);
  }


  /* ------------------------------------------
     DRAG / SWIPE HANDLING
  ------------------------------------------ */
  function attachDrag(card) {
    card.addEventListener('mousedown', onDragStart);
    card.addEventListener('touchstart', onDragStart, { passive: true });
    card.addEventListener('touchmove', onTouchMove, { passive: false });
    card.addEventListener('touchend', onDragEnd);
  }

  function onDragStart(e) {
    if (state.isVerdictShowing || state.isDragging) return;

    var touch = e.touches ? e.touches[0] : e;
    state.isDragging = true;
    state.dragStartX = touch.clientX;
    state.dragStartY = touch.clientY;
    state.dragCurrentX = 0;
    state.isHorizontalDrag = null;

    e.currentTarget.style.transition = 'none';
    e.currentTarget.classList.add('tmb-card--dragging');

    if (!e.touches) {
      document.addEventListener('mousemove', onMouseMove);
      document.addEventListener('mouseup', onDragEnd);
    }
  }

  function onMouseMove(e) {
    if (!state.isDragging) return;
    var card = el.cardStack.querySelector('.tmb-card--active');
    if (!card) return;
    applyDrag(card, e.clientX - state.dragStartX);
  }

  function onTouchMove(e) {
    if (!state.isDragging) return;

    var dx = e.touches[0].clientX - state.dragStartX;
    var dy = e.touches[0].clientY - state.dragStartY;

    // Determine swipe axis on first significant movement
    if (state.isHorizontalDrag === null && (Math.abs(dx) > 4 || Math.abs(dy) > 4)) {
      state.isHorizontalDrag = Math.abs(dx) > Math.abs(dy);
    }

    if (state.isHorizontalDrag) {
      e.preventDefault();
      applyDrag(e.currentTarget, dx);
    }
    // If vertical → let browser scroll naturally
  }

  function applyDrag(card, dx) {
    state.dragCurrentX = dx;

    var rotation = Math.max(-15, Math.min(15, dx * 0.08));
    card.style.transform = 'translateX(' + dx + 'px) rotate(' + rotation + 'deg)';

    var progress = Math.min(Math.abs(dx) / 110, 1);
    var trueOv   = card.querySelector('.tmb-overlay-true');
    var falseOv  = card.querySelector('.tmb-overlay-false');

    if (dx > 0) {
      if (trueOv)  trueOv.style.opacity  = progress;
      if (falseOv) falseOv.style.opacity = 0;
    } else {
      if (falseOv) falseOv.style.opacity = progress;
      if (trueOv)  trueOv.style.opacity  = 0;
    }
  }

  function onDragEnd(e) {
    if (!state.isDragging) return;
    state.isDragging = false;
    state.isHorizontalDrag = null;

    document.removeEventListener('mousemove', onMouseMove);
    document.removeEventListener('mouseup', onDragEnd);

    var card = el.cardStack.querySelector('.tmb-card--active');
    if (!card) return;
    card.classList.remove('tmb-card--dragging');

    var THRESHOLD = 90;

    if (Math.abs(state.dragCurrentX) > THRESHOLD) {
      triggerAnswer(state.dragCurrentX > 0);
    } else {
      snapBack(card);
    }
  }

  function snapBack(card) {
    card.style.transition = 'transform 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275)';
    card.style.transform = 'translateX(0) rotate(0deg)';
    var trueOv  = card.querySelector('.tmb-overlay-true');
    var falseOv = card.querySelector('.tmb-overlay-false');
    if (trueOv)  trueOv.style.opacity  = 0;
    if (falseOv) falseOv.style.opacity = 0;
  }


  /* ------------------------------------------
     ANSWER PROCESSING
  ------------------------------------------ */
  function triggerAnswer(userSaysTrue) {
    if (state.isVerdictShowing) return;
    state.isVerdictShowing = true;

    if (!state.gameStarted) {
      state.gameStarted = true;
      trackEvent('game_start', { total_myths: state.myths.length });
    }

    var card = el.cardStack.querySelector('.tmb-card--active');

    // Animate card off-screen
    if (card) {
      var dir = userSaysTrue ? 1 : -1;
      var ov = card.querySelector(userSaysTrue ? '.tmb-overlay-true' : '.tmb-overlay-false');
      if (ov) ov.style.opacity = '1';

      card.style.transition = 'transform 0.42s cubic-bezier(0.55, 0, 1, 0.45), opacity 0.3s 0.12s';
      card.style.transform = 'translateX(' + (dir * 140) + 'vw) rotate(' + (dir * 22) + 'deg)';
      card.style.opacity = '0';
      card.style.pointerEvents = 'none';
    }

    var myth = state.myths[state.currentIndex];
    var isCorrect = (userSaysTrue === myth.answer);

    if (isCorrect) {
      state.score++;
      bumpScore();
    } else if (myth.relatedProductId) {
      state.wrongProductIds.push(myth.relatedProductId);
    }

    // Update answered count in header
    if (el.answeredCount) el.answeredCount.textContent = state.currentIndex + 1;
    if (el.scoreCount)    el.scoreCount.textContent    = state.score;

    updateProgressBar(state.currentIndex + 1);

    trackEvent('myth_swipe', {
      myth_id: myth.id,
      category: myth.category,
      user_answer: userSaysTrue,
      correct: isCorrect,
      index: state.currentIndex,
    });

    setTimeout(function () {
      showVerdict(myth, isCorrect);
    }, 420);
  }

  function showVerdict(myth, isCorrect) {
    el.actionBtns.style.display = 'none';
    el.cardStack.innerHTML = '';

    el.verdictIcon.textContent  = isCorrect ? '✅' : '❌';
    el.verdictLabel.textContent = isCorrect ? 'Correct!' : 'Nope!';
    el.verdictLabel.className   = 'tmb-verdict-label ' +
      (isCorrect ? 'tmb-verdict-label--correct' : 'tmb-verdict-label--wrong');
    el.verdictExpl.textContent  = myth.explanation;

    el.verdict.className = 'tmb-verdict ' +
      (isCorrect ? 'tmb-verdict--correct' : 'tmb-verdict--wrong');
    el.verdict.style.display = 'flex';
  }

  function nextMyth() {
    state.currentIndex++;
    if (state.currentIndex >= state.myths.length) {
      showFinalScore();
    } else {
      renderCurrentCard();
    }
  }


  /* ------------------------------------------
     PROGRESS UI
  ------------------------------------------ */
  function updateProgressUI() {
    var displayed = state.currentIndex + 1;
    if (el.mythNum)       el.mythNum.textContent       = displayed;
    if (el.scoreCount)    el.scoreCount.textContent    = state.score;
    if (el.answeredCount) el.answeredCount.textContent = state.currentIndex;
    updateProgressBar(state.currentIndex);
  }

  function updateProgressBar(answered) {
    var pct = (answered / state.myths.length) * 100;
    if (el.progressFill) {
      el.progressFill.style.width = pct + '%';
    }
    if (el.progressBar) {
      el.progressBar.setAttribute('aria-valuenow', answered);
    }
  }

  function bumpScore() {
    if (!el.scoreCount) return;
    el.scoreCount.classList.remove('tmb-score-bump');
    // Force reflow to restart animation
    void el.scoreCount.offsetWidth;
    el.scoreCount.classList.add('tmb-score-bump');
  }


  /* ------------------------------------------
     FINAL SCORE SCREEN
  ------------------------------------------ */
  function showFinalScore() {
    trackEvent('game_complete', {
      score: state.score,
      total: state.myths.length,
      wrong_products: state.wrongProductIds,
    });

    el.gameSection.style.display = 'none';
    el.resultSection.style.display = 'flex';

    // Animate score count-up
    animateCount(0, state.score, 1100, function (val) {
      if (el.finalScoreNum) el.finalScoreNum.textContent = val;
    });

    // Animate ring
    setTimeout(function () {
      if (el.scoreRingFill) {
        var pct = state.score / state.myths.length;
        var circumference = 440;
        el.scoreRingFill.style.strokeDashoffset = circumference - (pct * circumference);
      }
    }, 100);

    // Result copy
    var headline = 'You scored ' + state.score + '/10!';
    if (el.resultHeadline) el.resultHeadline.textContent = headline;
    if (el.resultRank)     el.resultRank.textContent     = getRank(state.score);

    // Confetti for scores 7+
    if (state.score >= 7) launchConfetti();

    // Wire share links
    buildShareLinks();

    // Show products after a moment
    setTimeout(showProducts, 1400);

    el.resultSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  function getRank(score) {
    if (score <= 3)  return 'Tech Rookie 🐣  - Time to level up!';
    if (score <= 6)  return 'Tech Savvy 💡  - You know your stuff.';
    if (score <= 9)  return 'Hardware Hero 🔥  - Impressive!';
    return 'Tech Legend 🏆  - Nobody fooled you!';
  }

  function animateCount(from, to, duration, cb) {
    var start = null;
    function step(ts) {
      if (!start) start = ts;
      var elapsed  = ts - start;
      var progress = Math.min(elapsed / duration, 1);
      // Ease-out cubic
      var eased = 1 - Math.pow(1 - progress, 3);
      cb(Math.round(from + (to - from) * eased));
      if (progress < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }


  /* ------------------------------------------
     CONFETTI
  ------------------------------------------ */
  function launchConfetti() {
    if (!el.confetti) return;
    var colors = ['#00d4ff', '#00e676', '#ff3d71', '#ffd600', '#b388ff', '#ffffff', '#ff9800'];

    for (var i = 0; i < 90; i++) {
      (function (idx) {
        var p = document.createElement('div');
        p.className = 'tmb-confetti-particle';

        var color    = colors[Math.floor(Math.random() * colors.length)];
        var size     = Math.random() * 9 + 5;
        var isRect   = Math.random() > 0.6;
        var isCircle = !isRect && Math.random() > 0.5;
        var radius   = isCircle ? '50%' : isRect ? '1px' : '3px';
        var w        = isRect ? size * 2.2 : size;
        var delay    = Math.random() * 1.0;
        var dur      = Math.random() * 2.0 + 1.5;

        p.style.cssText =
          'left:' + (Math.random() * 100) + '%;' +
          'background:' + color + ';' +
          'width:' + w + 'px;' +
          'height:' + size + 'px;' +
          'border-radius:' + radius + ';' +
          'animation-delay:' + delay + 's;' +
          'animation-duration:' + dur + 's;';

        el.confetti.appendChild(p);

        setTimeout(function () {
          if (p.parentNode) p.parentNode.removeChild(p);
        }, (delay + dur + 0.5) * 1000);
      }(i));
    }
  }


  /* ------------------------------------------
     PRODUCT RECOMMENDATIONS
  ------------------------------------------ */
  function showProducts() {
    var prods = window.PRODUCTS || {};
    var allKeys = Object.keys(prods);

    // Deduplicate wrong product IDs, keeping only valid ones
    var seen = {};
    var wrongIds = state.wrongProductIds.filter(function (id) {
      if (!id || seen[id] || !prods[id]) return false;
      seen[id] = true;
      return true;
    });

    var toShow = [];
    var usedKeys = {};

    // Add collections matching wrong answers (up to 4)
    wrongIds.forEach(function (id) {
      if (toShow.length < 4) {
        toShow.push(prods[id]);
        usedKeys[id] = true;
      }
    });

    // Fill remaining slots with random collections
    if (toShow.length < 4) {
      var remaining = shuffle(allKeys.filter(function (k) { return !usedKeys[k]; }));
      remaining.forEach(function (k) {
        if (toShow.length < 4) toShow.push(prods[k]);
      });
    }

    if (el.productsTitle) {
      el.productsTitle.textContent = wrongIds.length > 0
        ? 'Based on what you got wrong, you might need these 👇'
        : 'You aced it! Check out our top picks 🎯';
    }

    if (!toShow.length || !el.productsGrid) return;

    el.productsGrid.innerHTML = toShow.map(function (prod, i) {
      return (
        '<div class="tmb-product-card" style="animation-delay:' + (i * 0.08) + 's">' +
          '<div class="tmb-product-img-wrap">' +
            '<img ' +
              'class="tmb-product-img" ' +
              'src="' + escHtml(prod.image) + '" ' +
              'alt="' + escHtml(prod.name) + '" ' +
              'loading="lazy" ' +
              'onerror="this.src=\'https://via.placeholder.com/300x200?text=Product\'"' +
            '>' +
          '</div>' +
          '<div class="tmb-product-body">' +
            '<h3 class="tmb-product-name">' + escHtml(prod.name) + '</h3>' +
            '<p class="tmb-product-pitch">' + escHtml(prod.pitch) + '</p>' +
            '<div class="tmb-product-footer">' +
              '<span class="tmb-product-price">' + escHtml(prod.price) + '</span>' +
              '<a ' +
                'href="' + escHtml(prod.url) + '" ' +
                'target="_blank" ' +
                'rel="noopener noreferrer" ' +
                'class="tmb-product-btn" ' +
                'data-product="' + escHtml(prod.name) + '" ' +
                'aria-label="Shop ' + escHtml(prod.name) + ' on TPSTech.in"' +
              '>Shop on TPSTech →</a>' +
            '</div>' +
          '</div>' +
        '</div>'
      );
    }).join('');

    // Attach product click tracking via event delegation
    el.productsGrid.addEventListener('click', function (e) {
      var btn = e.target.closest('.tmb-product-btn');
      if (btn) {
        trackEvent('product_click', { product: btn.dataset.product, score: state.score });
      }
    });

    el.productsSection.style.display = 'block';
    setTimeout(function () {
      el.productsSection.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }, 200);
  }


  /* ------------------------------------------
     SHARE
  ------------------------------------------ */
  function buildShareLinks() {
    var rank = getRank(state.score);
    var text = 'I scored ' + state.score + '/10 on the TPSTech Myth Busters challenge!\n' + rank + '\nCan you beat me? 👉';
    var url  = window.location.href;

    if (el.shareWa) {
      el.shareWa.href = 'https://wa.me/?text=' + encodeURIComponent(text + ' ' + url);
    }
    if (el.shareTw) {
      el.shareTw.href = 'https://twitter.com/intent/tweet?text=' +
        encodeURIComponent(text) + '&url=' + encodeURIComponent(url) +
        '&hashtags=TPSTech,TechMythBusters';
    }
  }

  function shareScore() {
    var rank = getRank(state.score);
    var shareText =
      'I scored ' + state.score + '/10 on the TPSTech Myth Busters challenge! ' +
      rank + '\n\nCan you beat me? 👉 ' + window.location.href;

    if (navigator.share) {
      navigator.share({
        title: 'Tech Myth Busters  - TPSTech.in',
        text: shareText,
      }).catch(function () {});
    } else {
      copyToClipboard(shareText, el.shareBtn);
    }

    trackEvent('score_shared', {
      score: state.score,
      method: navigator.share ? 'native_share' : 'clipboard',
    });
  }

  function copyToClipboard(text, btn) {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(text).then(function () {
        flashBtn(btn, '✅ Copied!');
      }).catch(function () {
        fallbackCopy(text);
      });
    } else {
      fallbackCopy(text);
    }
  }

  function fallbackCopy(text) {
    var ta = document.createElement('textarea');
    ta.value = text;
    ta.style.cssText = 'position:fixed;top:-9999px;left:-9999px';
    document.body.appendChild(ta);
    ta.focus();
    ta.select();
    try { document.execCommand('copy'); } catch (e) { window.prompt('Copy your score:', text); }
    document.body.removeChild(ta);
    if (el.shareBtn) flashBtn(el.shareBtn, '✅ Copied!');
  }

  function flashBtn(btn, msg) {
    if (!btn) return;
    var orig = btn.textContent;
    btn.textContent = msg;
    setTimeout(function () { btn.textContent = orig; }, 2200);
  }


  /* ------------------------------------------
     KEYBOARD NAVIGATION
  ------------------------------------------ */
  function handleKeydown(e) {
    // When verdict is showing, Enter/Space = next
    if (state.isVerdictShowing) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        nextMyth();
      }
      return;
    }

    if (e.key === 'ArrowLeft') {
      e.preventDefault();
      triggerAnswer(false);
    } else if (e.key === 'ArrowRight') {
      e.preventDefault();
      triggerAnswer(true);
    }
  }

  function showKbHint() {
    if (!el.kbHint) return;
    // Only show on devices likely to have keyboards
    if (window.matchMedia('(pointer: coarse)').matches) return;
    el.kbHint.classList.add('tmb-kb-hint--visible');
    setTimeout(function () {
      el.kbHint.classList.remove('tmb-kb-hint--visible');
    }, 3500);
  }


  /* ------------------------------------------
     RESET / PLAY AGAIN
  ------------------------------------------ */
  function resetGame() {
    state.myths           = shuffle(window.MYTHS || []).slice(0, 10);
    state.currentIndex    = 0;
    state.score           = 0;
    state.wrongProductIds = [];
    state.isVerdictShowing = false;
    state.isDragging       = false;
    state.gameStarted      = false;

    // Reset confetti
    if (el.confetti) el.confetti.innerHTML = '';

    // Reset ring
    if (el.scoreRingFill) el.scoreRingFill.style.strokeDashoffset = '440';

    // Reset score display
    if (el.scoreCount)    el.scoreCount.textContent    = '0';
    if (el.answeredCount) el.answeredCount.textContent = '0';
    if (el.progressFill)  el.progressFill.style.width  = '0%';

    // Reset product grid to avoid stale click listeners
    if (el.productsGrid) el.productsGrid.innerHTML = '';

    // Show game, hide result + products
    el.resultSection.style.display   = 'none';
    el.productsSection.style.display = 'none';
    el.gameSection.style.display     = 'flex';

    renderCurrentCard();

    el.gameSection.scrollIntoView({ behavior: 'smooth', block: 'start' });

    trackEvent('game_restart', {});
  }


  /* ------------------------------------------
     UTILITIES
  ------------------------------------------ */
  function getCategoryColor(category) {
    var map = {
      'BATTERY MYTH':     '#ffc107',
      'RAM MYTH':         '#b388ff',
      'SECURITY MYTH':    '#ff7043',
      'GAMING MYTH':      '#00d4ff',
      'STORAGE MYTH':     '#26c6da',
      'COOLING MYTH':     '#69f0ae',
      'GPU MYTH':         '#aed581',
      'POWER MYTH':       '#ffab40',
      'MAINTENANCE MYTH': '#90a4ae',
    };
    return map[category] || '#00d4ff';
  }

  // Fisher-Yates shuffle  - returns a new shuffled array
  function shuffle(arr) {
    var a = arr.slice();
    for (var i = a.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var tmp = a[i]; a[i] = a[j]; a[j] = tmp;
    }
    return a;
  }

  function escHtml(str) {
    if (typeof str !== 'string') return '';
    return str
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }


  /* ------------------------------------------
     BOOT
  ------------------------------------------ */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

}());
